import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-catalog-list-skeleton',
  templateUrl: './list-skeleton.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ListSkeletonComponent {
  readonly items: unknown[] = Array(2);
}
